<script>
  import { onMount } from "svelte"
  import * as d3 from "d3"
  var data = [130, 86, 168, 281, 303, 365]

  let el

  onMount(() => {
    d3.select(el)
      .selectAll("div")
      .data(data)
      .enter()
      .append("div")
      .style("width", function (d) {
        return d + "px"
      })
      .text(function (d) {
        return d
      })
  })
</script>

<main>
  <a href="/sandbox">Return to Sandbox</a>

  <h5>Simple horizontal bar chart - good for Gua statistics</h5>
  <p>Nothing fancy here. Just get it hooked up for reference.</p>
  <br />
  <div bind:this={el} class="chart" />
</main>

<style>
  .chart :global(div) {
    font: 10px sans-serif;
    background-color: rgb(173, 192, 65);
    text-align: right;
    padding: 3px;
    margin: 1px;
    color: white;
  }
</style>
